<template>

    <div v-html="formatted" @click.stop.prevent="clickLink"></div>

</template>

<script>

import MarkdownIt from 'markdown-it'

export default {

    name: 'formatting-link',

    props: {

        text: {
            type: String,
            default: ''
        },

        tags: {
            type: Array,
            default: () => []
        },

        blank: {
            type: Boolean,
            default: false
        },

        color: {
            type: String,
            default: ''
        },

        linkBold: {
            type: Boolean,
            default: false
        }

    },

    watch: {

        text: function (message) {

            if (this.updatetext) {

                this.updatetext(message)

            }

        }
    },

    data() {
        return {

            formatted: '',
            index: 0

        }
    },

    mounted() {

        this.updatetext(this.text)

    },

    methods: {

        updatetext(text) {

            const tempText = this.addLinks(text)

            this.formatted = this.colorText(tempText)

        },

        addLinks(string) {

            const md = new MarkdownIt()
            let markdownStr = md.render(string)

            const regexp = new RegExp('<a href="([^"]+)">([^<]+)</a>', 'g')

            let item

            while ((item = regexp.exec(markdownStr)) !== null) {
                const link = `<a class="link ${this.linkBold ? 'link-bold' : ''}"
                               data-target="${item[1]}"
                                href="${item[1]}"
                                ${this.blank ? 'target="_blank" rel="noopener noreferrer nofollow"' : ''}
                                 style="color:${this.color};"
                                 data-index="${this.index}">${item[2]}</a>`
                markdownStr = markdownStr.replace(item[0], link)

                this.index = this.index + 1
            }

            return markdownStr
        },

        colorText(str) {

            return str.replace(/<code>/g, `<span style="color: ${this.color};">`).replace(/<\/code>/g, '</span>')

        },

        clickLink(event) {
            if (event.target.getAttribute('data-target')) {

                const target = event.target.getAttribute('data-target').split('/').pop()

                if (this.tags.length > 0 && this.tags.indexOf(target) > -1) {
                    this.$emit('trackEvent', target)
                }

                const url = event.target.getAttribute('data-target')

                const matchedRoute = this.$router.matcher.match(url)
                if(matchedRoute.path !== '/') {
                    //internal redirect
                    this.$router.push({path: url})
                } else {
                    this.blank
                        ? window.open(url, '_blank', 'rel="noopener,noreferrer,nofollow"')
                        : window.location.href = url
                }
            }
        }
    }

}

</script>

<style lang="scss" scoped>


</style>
